<script setup>
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

defineProps({
  loading: { type: Boolean, default: false },
  responsibilities: { type: Array, default: () => [] },
});

const emit = defineEmits(['boleto']);
const { t } = useI18n();
const boletoActionAllowed = responsibility =>
  responsibility.acoes?.pode_enviar_boleto ||
  responsibility.boleto?.pode_baixar;
</script>

<template>
  <section
    class="rounded-lais border border-lais-border-soft bg-white p-6 shadow-lais-card sm:p-8"
  >
    <h2 class="font-redHatDisplay text-xl font-semibold text-lais-text">
      {{ t('REAL_ESTATE_FINANCE.STATUS_UPDATE.BOLETO_TITLE') }}
    </h2>
    <p class="mt-2 text-sm text-lais-text-muted">
      {{ t('REAL_ESTATE_FINANCE.STATUS_UPDATE.BOLETO_HELP') }}
    </p>
    <div class="mt-5 divide-y divide-lais-border-soft">
      <article
        v-for="responsibility in responsibilities"
        :key="responsibility.id"
        class="flex flex-wrap items-center justify-between gap-3 py-4 first:pt-0 last:pb-0"
      >
        <div>
          <p class="font-semibold text-lais-text">
            {{ responsibility.usuario_nome }}
          </p>
          <p class="mt-1 text-sm text-lais-text-muted">
            {{ responsibility.valor_pagamento?.amount }}
          </p>
        </div>
        <LaisPrimaryButton
          v-if="boletoActionAllowed(responsibility)"
          size="sm"
          type="button"
          variant="ghost"
          :disabled="loading"
          @click="emit('boleto', responsibility)"
        >
          {{ t('REAL_ESTATE_FINANCE.BOLETO.TITLE') }}
        </LaisPrimaryButton>
      </article>
    </div>
  </section>
</template>
